

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Card from "@/components/atoms/Card/index.vue";
import Information from "@/components/molecules/Information/index.vue";

@Component({
  components: { Card, Information },
})
export default class Dashboard extends Vue {
  @Prop() private infoList!: object;

  @Watch("infoList")
  private onChangeInfoList(val: any, oldVal: any) {
    this.infoList = val;
  }
}
